import { render, staticRenderFns } from "./ChartjsHorizontalBarChartProgressFixed.vue?vue&type=template&id=2e61947c&"
import script from "./ChartjsHorizontalBarChartProgressFixed.vue?vue&type=script&lang=js&"
export * from "./ChartjsHorizontalBarChartProgressFixed.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsHorizontalBarChartProgressFixed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports